/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const physicalInfrastructureEnumsCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    Busy: 'Busy',
    Overwhelmed: 'Overwhelmed',
    Saturated: 'Saturated',
    Other: 'Other',
} as const;

export type PhysicalInfrastructureEnumsCurrentStatusOptionEnumKey =
    (typeof physicalInfrastructureEnumsCurrentStatusOptionEnum)[keyof typeof physicalInfrastructureEnumsCurrentStatusOptionEnum];

export type PhysicalInfrastructureEnumsCurrentStatusOption = PhysicalInfrastructureEnumsCurrentStatusOptionEnumKey;
